/* ZINGI cart drawer: window.ZingiCart (Shopify AJAX Cart API). Markup: snippets/zingi-cart-drawer.liquid */
(function () {
  'use strict';

  var root = document.getElementById('ZingiCartDrawer');
  if (!root || window.ZingiCart) return;

  var cfg = {};
  try { cfg = JSON.parse(document.getElementById('ZingiCartConfig').textContent); } catch (e) {}

  var MAIN = cfg.mainHandle || 'zingi-suc-natural-ghimbir-lamaie-miere';
  var PACK = cfg.packHandle || 'pachet-de-3-zingi-x-500ml';
  var ROOT_URL = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var url = function (p) { return ROOT_URL.replace(/\/$/, '') + p; };

  var panel = root.querySelector('.zc__panel');
  var q = function (sel) { return root.querySelector(sel); };
  var el = {
    title: q('[data-zc-title]'),
    error: q('[data-zc-error]'),
    ship: q('.zc__ship'),
    shipLabel: q('[data-zc-ship-label]'),
    bar: q('[data-zc-bar]'),
    barFill: q('[data-zc-bar-fill]'),
    items: q('[data-zc-items]'),
    up: q('[data-zc-up]'),
    upImg: q('[data-zc-up-img]'),
    upTitle: q('[data-zc-up-title]'),
    upSub: q('[data-zc-up-sub]'),
    upBtn: q('[data-zc-up-btn]'),
    gift: q('[data-zc-gift]'),
    giftRow: q('[data-zc-gift-row]'),
    subtotal: q('[data-zc-subtotal]'),
    discountRow: q('[data-zc-discount-row]'),
    discount: q('[data-zc-discount]'),
    shipCost: q('[data-zc-ship]'),
    total: q('[data-zc-total]'),
    cta: q('[data-zc-cta]'),
    empty: q('[data-zc-empty]')
  };

  /* ---------- Strings (rendered from Liquid in layout/theme.liquid) ---------- */
  var I18N = window.ZingiI18n || {};
  var T = I18N.cart || {};
  function t(key, fallback, vars) {
    var str = T[key] != null ? String(T[key]) : fallback;
    if (vars) Object.keys(vars).forEach(function (k) { str = str.split('[' + k + ']').join(vars[k]); });
    return str;
  }

  /* ---------- Currency ---------- */
  function currency() {
    return (window.Shopify && Shopify.currency && Shopify.currency.active) || cfg.currency || 'RON';
  }
  // RON -> active currency rate (1 for RON). Amounts below are RON bani, converted at render time.
  function rate() {
    var r = window.Shopify && Shopify.currency ? parseFloat(Shopify.currency.rate) : NaN;
    return isFinite(r) && r > 0 ? r : 1;
  }
  function conv(bani) { return Math.round(bani * rate()); }
  var SHIPPING_RON = 2000; // Sameday, in RON bani
  var THRESHOLD_RON = 19900; // free-shipping value threshold, in RON bani
  var MAIN_PRICE_RON = 9999; // fallbacks when the product prices are missing from the config
  var PACK_PRICE_RON = 27500;
  function shipping() { return conv(SHIPPING_RON); }
  function mainPrice() { return Number(cfg.mainPrice) > 0 ? Number(cfg.mainPrice) : conv(MAIN_PRICE_RON); }
  function packPrice() { return Number(cfg.packPrice) > 0 ? Number(cfg.packPrice) : conv(PACK_PRICE_RON); }
  var state = { cart: cfg.cart || null, upsell: null, lastFocus: null };

  /* ---------- Money (RO style: 1.234,56 lei; other currencies via Intl in the page locale) ---------- */
  var LOCALES = { ro: 'ro-RO', hu: 'hu-HU', bg: 'bg-BG', en: 'en-GB' };
  function money(cents, whole) {
    var cur = currency();
    var n = (Number(cents) || 0) / 100;
    if (cur === 'RON') {
      if (whole) return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' lei';
      var parts = n.toFixed(2).split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1] + ' lei';
    }
    var lang = String(I18N.locale || document.documentElement.lang || 'ro').toLowerCase().split('-')[0];
    var digits = whole || cur === 'HUF' ? 0 : 2;
    try {
      return new Intl.NumberFormat(LOCALES[lang] || lang, {
        style: 'currency', currency: cur, minimumFractionDigits: digits, maximumFractionDigits: digits
      }).format(n);
    } catch (e) { return n.toFixed(digits).replace('.', ',') + ' ' + cur; }
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- AJAX ---------- */
  function request(path, body) {
    var opts = { headers: { Accept: 'application/json' }, credentials: 'same-origin' };
    if (body) {
      opts.method = 'POST';
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    return fetch(url(path), opts).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok || data.status) {
          var err = new Error(data.description || data.message || t('errorUpdate', 'Nu am putut actualiza coșul. Încearcă din nou.'));
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  function refresh() {
    return request('/cart.js').then(render);
  }

  function withRefresh(promise) {
    clearError();
    return promise.then(refresh).catch(function (err) {
      showError(err.message);
      return refresh().then(function () { throw err; });
    });
  }

  function add(items) {
    if (!Array.isArray(items)) items = [items];
    items = items.map(function (it) {
      return { id: Number(it.id), quantity: Number(it.quantity) || 1, properties: it.properties, selling_plan: it.selling_plan };
    });
    clearError();
    return request('/cart/add.js', { items: items })
      .then(refresh)
      .then(function (cart) { open(); return cart; })
      .catch(function (err) {
        showError(err.message);
        return refresh().then(function () { open(); throw err; });
      });
  }

  function change(key, quantity) {
    return withRefresh(request('/cart/change.js', { id: key, quantity: quantity }));
  }

  function update(body) {
    return withRefresh(request('/cart/update.js', body));
  }

  /* ---------- Rules ---------- */
  // Match by product id first: handles can be translated in other locales.
  function isMainItem(it) { return (cfg.mainProductId && it.product_id === cfg.mainProductId) || it.handle === MAIN; }
  function isPackItem(it) { return (cfg.packProductId && it.product_id === cfg.packProductId) || it.handle === PACK; }

  function analyse(cart) {
    var mainQty = 0, packQty = 0, mainLine = null;
    (cart.items || []).forEach(function (it) {
      if (isMainItem(it)) { mainQty += it.quantity; if (!mainLine) mainLine = it; }
      if (isPackItem(it)) packQty += it.quantity;
    });
    return { mainQty: mainQty, packQty: packQty, mainLine: mainLine, free: packQty > 0 || mainQty >= 2 };
  }

  /* ---------- Render ---------- */
  var ICON_MINUS = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 12h12"/></svg>';
  var ICON_PLUS = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 12h12M12 6v12"/></svg>';
  var ICON_CHECK = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  function lineHTML(it, info) {
    var isMain = isMainItem(it), isPack = isPackItem(it);
    var title = (isMain || isPack) ? 'ZINGI · 500 ml' : it.product_title;
    var img = isMain ? cfg.bottleImg : isPack ? cfg.packImg : (it.image || cfg.bottleImg);
    var alt = isMain ? t('bottleAlt', 'Sticlă ZINGI 500 ml') : isPack ? t('packAlt', 'Pachet familie ZINGI, 3 sticle de 500 ml') : it.product_title;
    var meta = '';
    // Per-dose prices: 1 bottle = 10 doses of 50 ml.
    if (isMain && it.quantity === 1 && !info.free) meta = t('perDoseShipping', '≈ [price]/doză cu transport', { price: money((mainPrice() + shipping()) / 10) });
    else if (isMain && it.quantity === 2) meta = t('perDoseFree', '≈ [price]/doză · transport gratuit', { price: money(mainPrice() * 2 / 20, true) });
    else if (isPack && it.quantity === 1) meta = t('perDoseFree', '≈ [price]/doză · transport gratuit', { price: money(packPrice() / 30) });
    else if (!isMain && !isPack && it.variant_title && !it.product_has_only_default_variant) meta = it.variant_title;
    var dec = it.quantity <= 1;
    var name = isPack ? t('packName', 'Pachet familie ZINGI') : isMain ? 'ZINGI 500 ml' : it.product_title;

    return '<li class="zc__item" data-key="' + esc(it.key) + '" data-qty="' + it.quantity + '">' +
      '<img class="zc__item-img" src="' + esc(img) + '" alt="' + esc(alt) + '" width="84" height="96" loading="eager">' +
      '<div class="zc__item-main">' +
        '<div class="zc__item-top"><strong>' + esc(title) + '</strong><strong>' + money(it.final_line_price) + '</strong></div>' +
        (meta ? '<span class="zc__item-meta">' + esc(meta) + '</span>' : '') +
        (isPack ? '<span class="zc__item-pack">' + ICON_CHECK + esc(t('packApplied', 'Preț Pachet familie aplicat')) + ' <span>' + esc(t('packSeparately', 'separat: [price]', { price: money(mainPrice() * 3 * it.quantity) })) + '</span></span>' : '') +
        '<div class="zc__item-row">' +
          '<div class="zc__qty" role="group" aria-label="' + esc(t('qtyGroup', 'Cantitate, [name]', { name: name })) + '">' +
            '<button type="button" data-zc-dec aria-label="' + esc(t('qtyDec', 'Scade cantitatea')) + '" aria-disabled="' + dec + '">' + ICON_MINUS + '</button>' +
            '<output aria-live="polite">' + it.quantity + '</output>' +
            '<button type="button" data-zc-inc aria-label="' + esc(t('qtyInc', 'Crește cantitatea')) + '" aria-disabled="false">' + ICON_PLUS + '</button>' +
          '</div>' +
          '<button type="button" class="zc__remove" data-zc-remove aria-label="' + esc(t('removeLabel', 'Elimină [name] din coș', { name: name })) + '">' + esc(t('remove', 'Elimină')) + '</button>' +
        '</div>' +
      '</div>' +
    '</li>';
  }

  function render(cart) {
    if (!cart || !cart.items) return cart;
    state.cart = cart;
    var info = analyse(cart);
    var count = cart.item_count || 0;
    var isEmpty = count === 0;

    el.title.textContent = t('title', 'Coșul tău ([count])', { count: count });
    root.querySelectorAll('[data-zc-filled]').forEach(function (n) { n.hidden = isEmpty; });
    el.empty.hidden = !isEmpty;

    // Free-shipping progress
    var pct = info.free ? 100 : Math.max(0, Math.min(99, Math.round(cart.items_subtotal_price / conv(THRESHOLD_RON) * 100)));
    el.ship.classList.toggle('is-free', info.free);
    el.shipLabel.textContent = info.free
      ? t('shipFree', 'Ai transport gratuit')
      : info.mainQty === 1
        ? t('shipOne', 'Adaugă a doua sticlă și transportul e gratuit — plătești doar [price] în plus.', { price: money(mainPrice() - shipping()) })
        : t('shipOther', 'Adaugă 2 sticle ZINGI sau Pachetul familie și transportul e gratuit.');
    el.bar.setAttribute('aria-valuenow', String(pct));
    el.barFill.style.width = pct + '%';

    // Lines (keep keyboard focus on the same control across re-renders)
    var act = document.activeElement, refocus = null;
    if (act && el.items.contains(act)) {
      var li = act.closest('.zc__item');
      refocus = { key: li && li.getAttribute('data-key'), ctl: act.hasAttribute('data-zc-inc') ? 'data-zc-inc' : act.hasAttribute('data-zc-dec') ? 'data-zc-dec' : 'data-zc-remove' };
    }
    el.items.innerHTML = cart.items.map(function (it) { return lineHTML(it, info); }).join('');

    if (refocus) {
      var target = null;
      el.items.querySelectorAll('.zc__item').forEach(function (n) { if (n.getAttribute('data-key') === refocus.key) target = n.querySelector('[' + refocus.ctl + ']'); });
      (target || el.items.querySelector('button') || root.querySelector('.zc__close')).focus();
    }

    // Upsell
    state.upsell = null;
    if (!info.packQty && info.mainLine && info.mainQty === 1) {
      state.upsell = {
        type: 'second',
        title: t('upSecondTitle', 'Adaugă a doua sticlă · +[price]', { price: money(mainPrice()) }),
        sub: t('upSecondSub', 'Și transportul devine gratuit'),
        cta: t('upSecondCta', '+1 sticlă'),
        img: cfg.bottleImg,
        alt: t('bottleAlt', 'Sticlă ZINGI 500 ml')
      };
    } else if (!info.packQty && info.mainLine && info.mainQty === 2 && info.mainLine.quantity === 2 && cfg.packVariantId) {
      state.upsell = {
        type: 'pack',
        title: t('upPackTitle', 'Treci la Pachetul familie: +[price] pentru a 3-a sticlă', { price: money(packPrice() - mainPrice() * 2) }),
        sub: t('upPackSub', '[unit]/sticlă · economisești [saving]', { unit: money(packPrice() / 3), saving: money(mainPrice() * 3 - packPrice()) }),
        cta: t('upPackCta', 'Treci la 3'),
        img: cfg.packImg,
        alt: t('packAltShort', 'Pachet familie ZINGI, 3 sticle')
      };
    }
    el.up.hidden = !state.upsell;
    if (!state.upsell && document.activeElement === el.upBtn) (el.items.querySelector('button') || root.querySelector('.zc__close')).focus();
    if (state.upsell) {
      el.upImg.src = state.upsell.img;
      el.upImg.alt = state.upsell.alt;
      el.upTitle.textContent = state.upsell.title;
      el.upSub.textContent = state.upsell.sub;
      el.upBtn.textContent = state.upsell.cta;
      el.upBtn.disabled = false;
    }

    // Gift wrap
    var gift = !!(cart.attributes && cart.attributes['Ambalaj cadou'] === 'Da');
    el.gift.checked = gift;
    el.giftRow.hidden = !gift;

    // Summary
    var discount = Math.max(0, cart.items_subtotal_price - cart.total_price);
    var ship = info.free ? 0 : shipping();
    var total = cart.total_price + ship;
    el.subtotal.textContent = money(cart.items_subtotal_price);
    el.discountRow.hidden = discount === 0;
    el.discount.textContent = '−' + money(discount);
    el.shipCost.textContent = info.free ? t('free', 'Gratuit') : money(ship);
    el.shipCost.classList.toggle('is-free', info.free);
    el.total.textContent = money(total);
    el.cta.textContent = t('checkout', 'Finalizează comanda') + ' · ' + money(total);

    // Header count(s)
    document.querySelectorAll('[data-zingi-cart-count]').forEach(function (n) {
      n.textContent = String(count);
      n.setAttribute('data-count', String(count));
    });

    document.dispatchEvent(new CustomEvent('zingi:cart:updated', { detail: { cart: cart } }));
    return cart;
  }

  function showError(msg) { el.error.textContent = msg; el.error.hidden = false; }
  function clearError() { el.error.hidden = true; el.error.textContent = ''; }

  /* ---------- Open / close + focus management ---------- */
  function focusables() {
    return Array.prototype.filter.call(
      panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      function (n) { return n.offsetParent !== null || n === document.activeElement; }
    );
  }

  function isOpen() { return !root.hidden; }

  function open() {
    if (isOpen()) return;
    state.lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('zc-lock');
    // next frame so the transition runs
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { root.classList.add('is-open'); });
    });
    panel.focus();
    document.dispatchEvent(new CustomEvent('zingi:cart:opened'));
  }

  function close() {
    if (!isOpen()) return;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('zc-lock');
    var done = function () { if (!root.classList.contains('is-open')) root.hidden = true; };
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) done(); else setTimeout(done, 300);
    if (state.lastFocus && state.lastFocus.focus) state.lastFocus.focus();
    document.dispatchEvent(new CustomEvent('zingi:cart:closed'));
  }

  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) { e.preventDefault(); return; }
    var first = f[0], last = f[f.length - 1];
    if (!panel.contains(document.activeElement)) { e.preventDefault(); (e.shiftKey ? last : first).focus(); return; }
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- Drawer interactions ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-zc-close]')) { close(); return; }

    var line = t.closest('.zc__item');
    if (line) {
      var key = line.getAttribute('data-key');
      var qty = parseInt(line.getAttribute('data-qty'), 10) || 1;
      var btn = t.closest('[data-zc-dec],[data-zc-inc],[data-zc-remove]');
      if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
      var next = btn.hasAttribute('data-zc-inc') ? qty + 1 : btn.hasAttribute('data-zc-dec') ? qty - 1 : 0;
      line.classList.add('is-busy');
      change(key, next).catch(function () {});
      return;
    }

    if (t.closest('[data-zc-up-btn]') && state.upsell) {
      var info = analyse(state.cart);
      el.upBtn.disabled = true;
      if (state.upsell.type === 'second') {
        change(info.mainLine.key, 2).catch(function () {});
      } else {
        // 2 bottles -> Pachet familie: remove the bottles, add the pack
        var updates = {};
        updates[info.mainLine.key] = 0;
        withRefresh(
          request('/cart/update.js', { updates: updates }).then(function () {
            return request('/cart/add.js', { items: [{ id: Number(cfg.packVariantId), quantity: 1 }] });
          })
        ).catch(function () {});
      }
    }
  });

  el.gift.addEventListener('change', function () {
    update({ attributes: { 'Ambalaj cadou': el.gift.checked ? 'Da' : '' } }).catch(function () {});
  });

  /* ---------- Global hooks ---------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-zingi-cart-open]');
    if (!trigger || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    e.preventDefault();
    open();
    refresh().catch(function () {});
  });

  document.addEventListener('zingi:cart:open', function () { open(); refresh().catch(function () {}); });

  // Progressive enhancement for ZINGI add-to-cart forms that no section script handled.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (e.defaultPrevented || !form.closest || !form.closest('.z-scope')) return;
    var action = form.getAttribute('action') || '';
    if (!/\/cart\/add\/?$/.test(action.split('?')[0])) return;
    var id = form.querySelector('[name="id"]');
    if (!id || !id.value) return;
    e.preventDefault();
    var qtyInput = form.querySelector('[name="quantity"]');
    var submitter = e.submitter || form.querySelector('[type="submit"]');
    if (submitter) submitter.setAttribute('aria-busy', 'true');
    add([{ id: id.value, quantity: qtyInput ? qtyInput.value : 1 }])
      .catch(function () {})
      .then(function () { if (submitter) submitter.removeAttribute('aria-busy'); });
  });

  // Keep counts fresh when returning via bfcache.
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh().catch(function () {}); });

  window.ZingiCart = {
    add: add,
    open: open,
    close: close,
    refresh: refresh,
    change: change,
    update: update,
    getCart: function () { return state.cart; },
    formatMoney: money
  };

  if (state.cart) render(state.cart);
})();
